import MainModal from '@/common/components/base/modal/Modal.tsx';
import { Center, Flex } from 'styled-system/jsx';
import EditIcon from '@/common/assets/icons/blueEditIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import Button from '@/common/components/base/button/Button.tsx';
import { UseSignatureReturn } from '@/common/hooks/useSignature.ts';

export default ({
  open,
  closeModal,
  exitPreviewMode,
}: MainModalProps & Pick<UseSignatureReturn, 'exitPreviewMode'>) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <EditSign exitPreviewMode={exitPreviewMode} closeModal={closeModal} />
    </MainModal>
  );
};

const EditSign = ({
  closeModal,
  exitPreviewMode,
}: Pick<MainModalProps, 'closeModal'> &
  Pick<UseSignatureReturn, 'exitPreviewMode'>) => {
  return (
    <Center flexDirection="column">
      <EditIcon />
      <Typography my="15px">آیا از ویرایش امضا مطمئن هستید ؟</Typography>
      <Typography color="black-3" textStyle="b2">
        در این صورت امضای قبلی شما حذف خواهد شد
      </Typography>
      <Flex mb="20px" mt="30px" w="100%" gap="10px">
        <Button
          onClick={closeModal}
          color="common"
          variant="outlined"
          fullWidth
        >
          انصراف
        </Button>
        <Button onClick={exitPreviewMode} fullWidth>
          ویرایش
        </Button>
      </Flex>
    </Center>
  );
};
